import {
    LibraryShapeId,
    OpeningShapeId,
    TrayShapeId,
    WardrobeShapeId,
} from '@core/constants/Shape';
import { FieldDimensionId } from '@core/constants/FieldDimension';
import { MaterialId } from '@core/constants/Material';
import {
    IFormInputType,
    IDimensionUnit,
    IFormFieldDimensionDefaultValueKey,
    IFormFieldShapeDimension,
    IFormFieldMaterial,
    IFormFieldShapeQuantities,
} from '../../../interfaces/Form';
import {
    getMaterialsWithExceptions,
    allMelamine,
    allGlasses,
    allMetals,
    allRecycledWoods,
    allWoods,
} from './materialGroups';

export const fieldsWardrobeShapeDimension: IFormFieldShapeDimension = {
    shape: {
        value   : undefined,
        options : [
            TrayShapeId.SingleShape,
            TrayShapeId.LShape,
            TrayShapeId.UShape,
        ],
        required: true,
    },
    dimension: {
        options: {
            [TrayShapeId.SingleShape]: {
                [FieldDimensionId.Height]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 100,
                    range        : { min: 1500, max: 3000 },
                    required     : true,
                    defaultValue : 1800,
                },
                [FieldDimensionId.Length]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 100,
                    range        : { min: 500, max: 3000 },
                    required     : true,
                    defaultValue : 1500,
                },
                [FieldDimensionId.Depth]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 10,
                    range        : { min: 300, max: 1000 },
                    required     : true,
                    defaultValue : 600,
                },
                [FieldDimensionId.Thickness]: {
                    value         : undefined,
                    type          : IFormInputType.Range,
                    unit          : IDimensionUnit.Centimeters,
                    step          : 10,
                    range         : { min: 10, max: 50 },
                    required      : true,
                    defaultValue  : 20,
                    defaultValues : [
                        [IFormFieldDimensionDefaultValueKey.StandardThickness, 20],
                    ],
                },
            },
            [TrayShapeId.LShape]: {
                [FieldDimensionId.Height1]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 100,
                    range        : { min: 1500, max: 3000 },
                    required     : true,
                    defaultValue : 1800,
                },
                [FieldDimensionId.Length1]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 100,
                    range        : { min: 500, max: 3000 },
                    required     : true,
                    defaultValue : 1500,
                },
                [FieldDimensionId.Depth1]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 10,
                    range        : { min: 300, max: 1000 },
                    required     : true,
                    defaultValue : 600,
                },
                [FieldDimensionId.Height2]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 100,
                    range        : { min: 1500, max: 3000 },
                    required     : true,
                    defaultValue : 1800,
                },
                [FieldDimensionId.Length2]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 100,
                    range        : { min: 500, max: 3000 },
                    required     : true,
                    defaultValue : 1500,
                },
                [FieldDimensionId.Depth2]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 10,
                    range        : { min: 300, max: 1000 },
                    required     : true,
                    defaultValue : 600,
                },
                [FieldDimensionId.Thickness]: {
                    value         : undefined,
                    type          : IFormInputType.Range,
                    unit          : IDimensionUnit.Centimeters,
                    step          : 10,
                    range         : { min: 10, max: 50 },
                    required      : true,
                    defaultValue  : 20,
                    defaultValues : [
                        [IFormFieldDimensionDefaultValueKey.StandardThickness, 20],
                    ],
                },
            },
            [TrayShapeId.UShape]: {
                [FieldDimensionId.Height1]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 100,
                    range        : { min: 1500, max: 3000 },
                    required     : true,
                    defaultValue : 1800,
                },
                [FieldDimensionId.Length1]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 100,
                    range        : { min: 500, max: 3000 },
                    required     : true,
                    defaultValue : 1500,
                },
                [FieldDimensionId.Depth1]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 10,
                    range        : { min: 300, max: 1000 },
                    required     : true,
                    defaultValue : 600,
                },
                [FieldDimensionId.Height2]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 100,
                    range        : { min: 1500, max: 3000 },
                    required     : true,
                    defaultValue : 1800,
                },
                [FieldDimensionId.Length2]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 100,
                    range        : { min: 500, max: 3000 },
                    required     : true,
                    defaultValue : 1500,
                },
                [FieldDimensionId.Depth2]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 10,
                    range        : { min: 300, max: 1000 },
                    required     : true,
                    defaultValue : 600,
                },
                [FieldDimensionId.Height3]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 100,
                    range        : { min: 1500, max: 3000 },
                    required     : true,
                    defaultValue : 1800,
                },
                [FieldDimensionId.Length3]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 100,
                    range        : { min: 500, max: 3000 },
                    required     : true,
                    defaultValue : 1500,
                },
                [FieldDimensionId.Depth3]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 10,
                    range        : { min: 300, max: 1000 },
                    required     : true,
                    defaultValue : 600,
                },
                [FieldDimensionId.Thickness]: {
                    value         : undefined,
                    type          : IFormInputType.Range,
                    unit          : IDimensionUnit.Centimeters,
                    step          : 10,
                    range         : { min: 10, max: 50 },
                    required      : true,
                    defaultValue  : 20,
                    defaultValues : [
                        [IFormFieldDimensionDefaultValueKey.StandardThickness, 20],
                    ],
                },
            },
        },
    },
};

export const fieldsWardrobeMaterial: IFormFieldMaterial = {
    material: {
        value   : undefined,
        options : getMaterialsWithExceptions([
            ...allWoods,
            ...allMelamine,
            ...allGlasses,
            ...allMetals,
        ],
        [
            ...allRecycledWoods,
            MaterialId.BlackLocust,
            MaterialId.Douglas,
            MaterialId.DouglasEngineered,
            MaterialId.DouglasVeneer,
            MaterialId.Redcedar,
            MaterialId.RedcedarEngineered,
            MaterialId.RedcedarVeneer,
            MaterialId.Larch,
            MaterialId.LarchEngineered,
            MaterialId.LarchVeneer,
            MaterialId.Padouk,
            MaterialId.PadoukEngineered,
            MaterialId.PadoukVeneer,
            MaterialId.Ipe,
            MaterialId.IpeEngineered,
            MaterialId.IpeVeneer,
            MaterialId.Poplar,
            MaterialId.PoplarVeneer,
            MaterialId.PoplarEngineered,
            MaterialId.DriftWood,
            MaterialId.Garapa,
            MaterialId.WroughtIron,
            MaterialId.SheetMetal,
        ]),
        required: true,
    },
};

export const fieldsWardrobeOpenings: IFormFieldShapeQuantities = {
    [OpeningShapeId.DoubleDoor]: {
        value : undefined,
        min   : 0,
        max   : 10,
    },
    [OpeningShapeId.SingleDoor]: {
        value : undefined,
        min   : 0,
        max   : 10,
    },
    [OpeningShapeId.SlidingDoors]: {
        value : undefined,
        min   : 0,
        max   : 10,
    },
};

export const fieldsWardrobeAddOns: IFormFieldShapeQuantities = {
    [WardrobeShapeId.BarHangerCloth]: {
        value : undefined,
        min   : 0,
        max   : 10,
    },
    [WardrobeShapeId.BeltHanger]: {
        value : undefined,
        min   : 0,
        max   : 10,
    },
    [WardrobeShapeId.DrawerCase]: {
        value : undefined,
        min   : 0,
        max   : 10,
    },
    [LibraryShapeId.Niche]: {
        value : undefined,
        min   : 0,
        max   : 10,
    },
    [WardrobeShapeId.PantsHanger]: {
        value : undefined,
        min   : 0,
        max   : 10,
    },
    [LibraryShapeId.Shelf]: {
        value : undefined,
        min   : 0,
        max   : 10,
    },
    [WardrobeShapeId.ShoesDrawer]: {
        value : undefined,
        min   : 0,
        max   : 10,
    },
    [WardrobeShapeId.TelescopicHangerCloth]: {
        value : undefined,
        min   : 0,
        max   : 10,
    },
    [WardrobeShapeId.TieHanger]: {
        value : undefined,
        min   : 0,
        max   : 10,
    },
    [WardrobeShapeId.WardrobeLight]: {
        value : undefined,
        min   : 0,
        max   : 10,
    },
};

